// window.GlobFunction = {
//   getDomain: function() {
//     return "nolimit.id";
//   },
//   getAccessToken: function() {
//     return "somerandomsuperaccess_token";
//   },
//   getTokenSecret: function() {
//     return "tokensecretwithtophasingsecuretoken";
//   },
//   getDomainId: function() {
//     return "originaliddarinolimit.com";
//   },
//   getDisplayPicture: function() {
//     return "https://www.lagioke.net/wp-content/uploads/2015/04/Gambar-Ilusi.jpg";
//   }
// };

// window.GlobFunction = {
//   getDomain: function() {
//     return "";
//   },
//   getAccessToken: function() {
//     return "";
//   },
//   getTokenSecret: function() {
//     return "";
//   },
//   getDomainId: function() {
//     return "";
//   },
//   getDisplayPicture: function() {
//     return "";
//   }
// };

export const Config = {
  // websocketUrl: "ws://localhost:9090/v1/tektok",
  websocketUrl: "wss://livechat.care.nolimit.id/v1/tektok",
  initialCode: "session:create",
  domain: function() {
    return window.GlobFunction.getDomain();
  },
  accessToken: function() {
    return window.GlobFunction.getAccessToken();
  },
  tokenSecret: function() {
    return window.GlobFunction.getTokenSecret();
  },
  domainId: function() {
    return window.GlobFunction.getDomainId();
  },
  displayPicture: function() {
    return window.GlobFunction.getDisplayPicture();
  },
  userAgent:
    "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_3) AppleWebKit/5.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36",
  timezone: -420
};



// WEBPACK FOOTER //
// ./src/constant.js